<template>
  <div
    class="train-item-wrapper"
    :class="{ selected: selected }"
    @click="change"
  >
    <img class="selected-icon" src="../../../public/img/card-select.png" />
    <p class="van-ellipsis title">
      {{ trainData.name }}
    </p>
    <div class="details-wrapper">
      <div class="details-item">
        <p class="title">部门：</p>
        <p class="content">
          {{ trainData.department }}
          <a-divider type="vertical" />
          城市：{{ trainData.cityName }}
        </p>
      </div>
      <div class="details-item">
        <p class="title">时间：</p>
        <p class="content">
          {{ moment(trainData.startDate).format('YYYY-MM-DD') }} 至
          {{ moment(trainData.endDate).format('YYYY-MM-DD') }}
        </p>
      </div>
      <div class="details-item">
        <p class="title">地点：</p>
        <p class="content">
          {{ trainData.location }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    trainData: Object,
    selected: Boolean,
  },
  data() {
    return {}
  },
  methods: {
    moment,
    change() {
      this.$emit('change', this.trainData.id)
    },
  },
}
</script>

<style lang="less" scoped>
.train-item-wrapper {
  margin: 0 12px 12px;
  border: 1px solid #f0f2f5;
  border-radius: 4px;
  padding: 12px;
  position: relative;
  background: #fff;
  &.selected {
    border-color: #1890ff;
    .selected-icon {
      display: block;
    }
  }
  .selected-icon {
    display: none;
    position: absolute;
    width: 24px;
    top: 0;
    right: 0;
  }
  & > .title {
    font-size: 16px;
    color: #333;
    line-height: 22px;
    margin-bottom: 8px;
    text-align: left;
  }
  .details-wrapper {
    .details-item {
      font-size: 12px;
      color: #9b9b9b;
      line-height: 20px;
      display: flex;
      &:not(:last-child) {
        margin-bottom: 4px;
      }
      .title,
      .content {
        margin-bottom: 0;
        text-align: left;
      }
      .title {
        width: 38px;
      }
      .content {
        width: calc(100% - 38px);
      }
    }
  }
}
</style>
